// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"18ac1102","246":"d3bb6473","285":"40891a2d","347":"a4956582","369":"60f00411","447":"faa720b9","523":"a395544c","614":"fe211826","618":"17eee731","719":"3db90c92","795":"07c449c5","840":"2a634e6d","875":"1c752c64","885":"d165f8fb","968":"e25cdee2"}[chunkId] + ".chunk.js";
};